<template>
    <div id="overlay" v-if="familyprofile_flg">
      <div id="message_area" style="height:70%;width:95%;max-width: 700px;min-height:300px;max-height:300px;background-color: white;">
        <div style="height:20%">
          <h3 class="kojin-title" style="margin:0">家族（複数人）登録の確認</h3>
        </div>
        <div style="width: 85%;
          margin: 3% auto auto;
          min-height: 0px;
          height: 70%;
          text-align: left;
          display: flex;
          flex-direction: column;
          justify-content: space-between;">

            きょうだいでの登録や、保護者の方が代理登録するなどの際にご利用ください。<br><br>

            尚、代理登録の場合は、この後のユーザー登録は、参加申込される当人のみ登録ください。<br>
            ※保護者の方も参加申込される場合は、ユーザー登録が必要です。 

          <div style="padding-bottom: 2%;display: flex; align-items: center; justify-content: center;">
            <button class="btn btn-primary mx-aut" style="width: 200px; height: 45px;margin: 10px 0px 0px 0px;background-color: blue;color:white;clear: right;"
            v-on:click="family_entry()">Ｏ&nbsp;&nbsp;Ｋ</button>&nbsp;&nbsp;
            <button class="btn btn-primary mx-aut" style="width: 200px; height: 45px;margin: 10px 0px 0px 0px;background-color: blue;color:white;clear: right;"
            v-on:click="familyprofile_close()">戻る</button>
          </div>
        </div>
      </div>
    </div>

    <!--メッセージを表示するモーダルウィンドウ-->
    <component v-bind:is="contentMessage"
              v-bind:message_text="message"
              v-bind:message_cat="message_cat"
              v-bind:message_flag="message_flag"
              @close_message="Close_message"
              @ok_message="OK_message"/>

</template>

<script setup>
/* eslint-disable */
import { ref } from 'vue'
import { GlobalData } from '../js/userdata.js';
/* メッセージを表示するモーダルウィンドウ */
import MessageModal from '../common/MessageModal.vue'  
import { useRouter, useRoute } from 'vue-router'

const router = useRouter();
let route = useRoute()

const cityname = route.params.shakyo

//const emit = defineEmits(['call' , 'multipleprofile_close']);

const emit = defineEmits(['ok_family','close_family']);

const props = defineProps(["familyprofile_flg"]);

let familyprofile_flg = ref(false);

let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ

/* 表示する子コンポーネント関係の情報 */
const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
contentMessage.value = null // 表示する子コンポーネント

familyprofile_flg.value = ref(props.familyprofile_flg);

const family_entry = () => {  //処理を続ける
    familyprofile_flg.value = false;
    emit('ok_family');
}

/*

let OK_message = function(){  //このウィンドウを閉じて親コンポーネント側で処理を行う
    message_flag0 = false;
    emit('ok_message',message_flag0);
}

let Close_message = function(){  //このウィンドウを閉じる
    message_flag0 = false;
    emit('close_message',message_flag0);
}

*/

// 体験プログラムキャンセル時、同時にキャンセルする事前説明会を抽出する（廃止）
// メッセージを表示するウィンドウでOKを押された時
const OK_message = function(){ 
    Close_message();//メッセージを表示するウィンドウを閉じる

//    if(message_method.value == "multipleUser_delete_check"){
//      // アカウントを削除しますか？
//      multipleUser_delete()
//    }
}

// メッセージを表示するウィンドウを閉じる
const Close_message = function(){
    message_flag.value = false;
    contentMessage.value = null
}

const familyprofile_close = () => {  //このウィンドウを閉じる
    familyprofile_flg.value = false;
    emit('close_family');
}

</script>
<style scoped>
#overlay{
  /* 要素を重ねた時の順番 */
  z-index:1000;

  /* 画面全体を覆う設定 */
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.5);

  /* 画面の中央に要素を表示させる設定 */
  display: flex;
  align-items: center;
  justify-content: center;
}
/* 種類列は要求通り display:none で非表示、ただしDOMには残す */
.type-col {
  display:none;
}

.t-block {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.highlight-row {
  background-color: #d6ffff; /* 条件一致時の色 */
}

</style>

